module.exports = __webpack_public_path__ + "static/media/cam-img.ba311665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cam-img.svg
// module id = 858
// module chunks = 0